import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto as employeeFromDto } from '../../../../models/adapters/EmployeeAdapter';
import { employeesInvited, employeesInviteFailed, inviteEmployees, InviteEmployeesPayload } from '../../../actions/setting/company/inviteEmployees';
import getAuthenticationToken from '../../getAuthenticationToken';
import getProtectedResponse from '../../getProtectedResponse';

function* inviteEmployeesSaga({ payload }: Action<InviteEmployeesPayload>) {
  const { invitations, companyUuid } = payload;
  const token = yield getAuthenticationToken();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.inviteEmployees, token, {
    invitations,
    companyUuid,
  });
  if (!response.error) {
    const employees = response.employees.map(employeeFromDto);
    yield put(employeesInvited({ employees, companyUuid }));
  } else {
    yield put(employeesInviteFailed({ invitations, companyUuid }));
  }
}

export default function* watchInviteEmployeesSaga() {
  yield takeEvery(inviteEmployees, inviteEmployeesSaga);
}
